import { Form, Mentions, Select } from 'antd'
import { useMemo } from 'react'

export default function AppointmentStatus({ fieldName, parameters }) {
  const available = useMemo(
    () => {
      const props = parameters?.properties
      if (!props) return []
      const arr = Array.isArray(props) ? props : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
      return arr.map(({ name }) => ({ label: name, value: name }))
    },
    [parameters]
  )

  return (
    <>
      <Form.Item
        label="ID do Agendamento"
        name={[fieldName, 'action', 'data', 'agendamento_id']}
        rules={[{ required: true, message: 'Obrigatório' }]}
      >
        <Select options={available} placeholder="Selecione um parâmetro" />
      </Form.Item>
      <Form.Item
        label="ID do Status"
        name={[fieldName, 'action', 'data', 'status_id']}
        rules={[{ required: true, message: 'Obrigatório' }]}
      >
        <Select options={available} placeholder="Selecione um parâmetro" />
      </Form.Item>
      <Form.Item label="Observações" name={[fieldName, 'action', 'data', 'obs']}>
        <Mentions prefix="$" split="" options={available} placeholder="Ex: Confirmado por $nome" />
      </Form.Item>
    </>
  )
}
